export default __webpack_public_path__ + "static/media/logo_alt.23cc1d49.xcf";